module.exports = __webpack_public_path__ + "static/img/device-3.26760a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/device-3.png
// module id = zMoV
// module chunks = 0